export const SW_INIT = {
    hasUpdate: false,
};
export const SW_UPDATE = 'SW_UPDATE';